module.exports = __webpack_public_path__ + "img/scene_17.8437f8a2.jpg";